import type React from 'react';

import * as styles from './action-item-group.css';

export interface ActionItemGroupProps {
  title: React.ReactNode;
  onTitleClick?: () => void;
  titleClassName?: string;
  titleStyle?: React.CSSProperties;
  headerActions?: React.ReactNode;
  renderList: (listClassName: string) => React.ReactNode;
  dataAttributes?: Record<string, string | undefined>;
}

export const ActionItemGroupComponent: React.FC<ActionItemGroupProps> = ({
  title,
  onTitleClick,
  titleClassName,
  titleStyle,
  headerActions,
  renderList,
  dataAttributes,
}) => {
  const resolvedTitleClassName =
    titleClassName ?? styles.groupDividerText;

  return (
    <div className={styles.sectionContainer} {...dataAttributes}>
      <div className={styles.groupDivider}>
        <div
          className={resolvedTitleClassName}
          onClick={onTitleClick}
          style={titleStyle}
        >
          {title}
        </div>
        {headerActions}
      </div>

      {renderList(styles.actionItemsList)}
    </div>
  );
};
